var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.shouldShowDialog)?_c('Dialog',{key:_vm.shouldShowDialogTimestamp},[_vm._t("dialog")],2):_vm._e(),_vm._t("default",null,{"shouldShowDialogUpdate":_vm.shouldShowDialogUpdate})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }